module.exports = __webpack_public_path__ + "static/media/Luna-Lovegood.b962b424.jpg";